export enum Platform {
  Android = 'android',
  Ios = 'ios',
  Web = 'web',
}
